import { render } from "./ItemSubCategory.vue?vue&type=template&id=46a61554&scoped=true"
import script from "./ItemSubCategory.vue?vue&type=script&lang=js"
export * from "./ItemSubCategory.vue?vue&type=script&lang=js"

import "./ItemSubCategory.vue?vue&type=style&index=0&id=46a61554&scoped=true&lang=css"
import "./ItemSubCategory.vue?vue&type=style&index=1&id=46a61554&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a61554"]])

export default __exports__